import { render, staticRenderFns } from "./CreateHolidayPlusChannel.vue?vue&type=template&id=554ae70f&scoped=true"
import script from "./CreateHolidayPlusChannel.vue?vue&type=script&lang=js"
export * from "./CreateHolidayPlusChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateHolidayPlusChannel.vue?vue&type=style&index=0&id=554ae70f&prod&lang=scss&scoped=true"
import style1 from "./CreateHolidayPlusChannel.vue?vue&type=style&index=1&id=554ae70f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ae70f",
  null
  
)

export default component.exports